import { render, staticRenderFns } from "./MainInstagram.vue?vue&type=template&id=0581aac1&scoped=true&"
import script from "./MainInstagram.vue?vue&type=script&lang=js&"
export * from "./MainInstagram.vue?vue&type=script&lang=js&"
import style0 from "./MainInstagram.vue?vue&type=style&index=0&id=0581aac1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0581aac1",
  null
  
)

export default component.exports